/* eslint-disable react/no-did-mount-set-state */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Careers from "./Careers";
import Article from "../../pages/Article/Article";
import {twillBase} from '../../config/API';

class CareersQuery extends Component {

    static propTypes = {
        id: PropTypes.number.isRequired,
        markComponentLoadedAs: PropTypes.func.isRequired,
        // eslint-disable-next-line react/forbid-prop-types
//        article: PropTypes.object
    };

    static defaultProps = {
        article: {}
    };

    static getStoryItems = async () => fetch(`${twillBase}/api/stories`).then(res => res.json())

    state = {
        story_items_api_call_completed: false,
        story_items: [],
    };

    async componentDidMount() {
        if (!this.state.story_items_api_call_completed) {
            const storyItems = await CareersQuery.getStoryItems();

            if (storyItems.length && !this.state.story_items.length) {

                const filteredAndSorted = storyItems
                    .sort((a, b) => new Date(b.story_date) - new Date(a.story_date));

                console.info(
                    "filteredAndSorted", filteredAndSorted
                );

                this.setState({
                    story_items: filteredAndSorted,
                    story_items_api_call_completed: true,
                })
            } else {
                this.setState({
                    story_items_api_call_completed: true,
                })
            }

        }
    }

    render() {
        if (!this.state.story_items_api_call_completed) return (<div className="pageLoader"/>);
        const {id, markComponentLoadedAs} = this.props;

        markComponentLoadedAs(id, true);

        const fetchedArticle = this.state.story_items.filter(item => item.id === id)[0];

        if (fetchedArticle && fetchedArticle.permalink) {
            return (<Article id={fetchedArticle.id}
                             // SupportingImage isn't currently used
                             supportingImage={{entity: {fieldMediaImage: fetchedArticle.featured_image}}}
                             type="career"
                             title={fetchedArticle.title}
                             subtitle={fetchedArticle.subtitle}
                             keyword={fetchedArticle.tags.map(tag => tag.name.trim())}
                             content={{processed: fetchedArticle.body}}
                             link={{uri: fetchedArticle.secondary_link}}
                             authors={fetchedArticle.authors}
                             date={{value: fetchedArticle.article_date}}
                             overrideVideoTitle={fetchedArticle.list_link_title}
                             knowledgeCenterItems={this.state.story_items}/>);
        }

        return (<Careers items={this.state.story_items} id={id} />);
    }

}

export default CareersQuery;



// WEBPACK FOOTER //
// ./frontend/components/Careers/CareersQuery.jsx